/**
 * Avisos no bloqueantes del panel — plan 27_09_2026 §4.2 (criterio C10).
 *
 * Reemplaza los `alert()` del área administrativa: bloqueaban el hilo, no
 * se podían encolar y rompían la identidad visual con un diálogo del sistema.
 *
 * Estado de módulo: cualquier vista llama a `notify.success(...)` sin recibir
 * nada por props; `AdmToastHost`, montado una sola vez en `AdminLayout`, los
 * pinta. Para confirmaciones que exigen respuesta se usa `AdmModal`, no esto.
 */

import { ref } from 'vue';

const toasts = ref([]);
let nextId = 1;

const DEFAULT_DURATION = 4000;

function push(tone, message, options = {}) {
  if (!message) return null;
  const id = nextId++;
  const duration = options.duration ?? DEFAULT_DURATION;

  toasts.value.push({ id, tone, message, title: options.title || '' });

  // duration <= 0 deja el aviso fijo hasta que el usuario lo cierre
  // (útil para errores que el operario debe leer sí o sí).
  if (duration > 0) {
    setTimeout(() => dismiss(id), duration);
  }
  return id;
}

export function dismiss(id) {
  toasts.value = toasts.value.filter((t) => t.id !== id);
}

export const notify = {
  success: (message, options) => push('ok', message, options),
  error: (message, options) => push('danger', message, { duration: 6000, ...options }),
  warn: (message, options) => push('warn', message, options),
  info: (message, options) => push('info', message, options),
};

export function useAdmToast() {
  return { toasts, notify, dismiss };
}

export default useAdmToast;
